import React, { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import MeetingControlBar from './MeetingControlBar'
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import Draggable from 'react-draggable';
import ScreenShotDialog from "./ScreenShotDialog"
import captureVideoFrame from "capture-video-frame";
import swal from 'sweetalert'
import Snackbar from '@material-ui/core/Snackbar';
import { isMobileSafari } from "react-device-detect"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Whiteboard from './whiteboard/Whiteboard'

// const VideoElements = ["","","","","","","","","","","","","","","","",]

const StyleSheet = {
    IsMobTab: {
        width: "100%",
        // height: "50%"
    },
    ScreenShareOn: {
        objectFit: "cover",
        height: "130px",
        width: "100%",
    },
    LessThanOrEqualTo1: {
        maxHeight: "99.5%",
        minHeight: "99.5%",
        maxWidth: "99.5%",
        objectFit: "cover"
    },
    EqualTo2: {
        maxHeight: "99.5%",
        minHeight: "99.5%",
        maxWidth: "49.5%",
        objectFit: "cover"
    },
    LessThanOrEqualTo4: {
        maxHeight: "49.5%",
        minHeight: "49.5%",
        maxWidth: "49.5%",
        minWidth: "49.5%",
        objectFit: "cover"
    },
    LessThanOrEqualTo6: {
        maxHeight: "49.5%",
        minHeight: "49.5%",
        maxWidth: "32.5%",
        minWidth: "32.5%",
        objectFit: "cover"
    },
    LessThanOrEqualTo7: {
        maxHeight: "32.5%",
        minHeight: "32.5%",
        maxWidth: "32.5%",
        minWidth: "32.5%",
        objectFit: "cover"
    },
    LessThanOrEqualTo12: {
        maxHeight: "32.5%",
        minHeight: "32.5%",
        maxWidth: "24.5%",
        minWidth: "24.5%",
        objectFit: "cover"
    },
    LessThanOrEqualTo16: {
        maxHeight: "24.5%",
        minHeight: "24.5%",
        maxWidth: "24.5%",
        minWidth: "24.5%",
        objectFit: "cover"
    },
    SpecialTabMoreThan4: {
        height: "49.5%",
        minHeight: "49.5%",
        maxHeight: "49.5%",
        width: "48%",
        minWidth: "48%",
        maxWidth: "48%"
    }

}

const VideoContainer = props => {

    const dispatch = useDispatch();

    const [People, setPeople] = useState({})
    const [PinnedID, setPinnedID] = useState(null)
    const [PinnedIndex, setPinnedIndex] = useState(null)
    const [NumberOfPeople, setNumberOfPeople] = useState(1)
    const [WIdth, setWIdth] = useState(0)
    const [ImageBase, setImageBase] = useState("")
    const [ScreenShotDialogOpen, setScreenShotDialogOpen] = useState(false)
    const [useLess, setuseLess] = useState(1)


    const People2 = useSelector(({ meeting }) => meeting.People)
    const VideoTilesPeople = useSelector(({ meeting }) => meeting.VideoTilesPeople)
    const Loading = useSelector(({ meeting }) => meeting.LoadingToStartAVideoSession);
    // const ScreenShareOn = true;
    const ScreenShareOn = useSelector(({ meeting }) => meeting.ScreenShareOn);
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)

    const ExerciseVideoShow = useSelector(({ meeting }) => meeting.ExerciseVideoShow);
    const ExerciseVideoPoster = useSelector(({ meeting }) => meeting.ExerciseVideoPoster);
    const ExerciseVideoVideo = useSelector(({ meeting }) => meeting.ExerciseVideoVideo);
    const LocalUserName = useSelector(({ meeting }) => meeting.LocalUserName);
    const isHost = useSelector(({ meeting }) => meeting.IsHost);
    const IsPatientHashMap = useSelector(({ meeting }) => meeting.IsPatientHashMap);
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);
    const SOAP = useSelector(({ meeting }) => meeting.SOAP)
    const PatientsList = useSelector(({ meeting }) => meeting.PatientsList)
    const SelectedPatientID = useSelector(({ meeting }) => meeting.SelectedPatientID)

    // console.log(IsPatientHashMap, "Patients")
    // console.log(People, "People")

    // const VideoTilesPeople = [1,2]
    // const IsMobTab = true
    const IsMobTab = window.innerWidth < 760 ? true : false; // true means tab and mob && false means desktop


    useEffect(() => {
        if (VideoTilesPeople && People && IsPatientHashMap) {
            if (!VideoTilesPeople.includes(People[IsPatientHashMap[`isPatientID${PinnedIndex}`]?.UserID]?.attendeeId)) {
                setPinnedID(null)
                setPinnedIndex(null)
            }
        }
    }, [VideoTilesPeople])

    useEffect(() => {
        setWIdth(window.innerWidth)
        window.addEventListener("resize", () => setWIdth(window.innerWidth))
    }, [])

    useEffect(() => {
        if (People2) setPeople(People2)
        UseLessFunction()

    }, [People2])

    // useEffect(() => {
    //     setNumberOfPeople(Object.keys(People).length)
    // }, [People])

    function UseLessFunction() {
        setuseLess(useLess + 1)

        setTimeout(() => {
            UseLessFunction()
        }, 2000);
    }

    function SaveScreenShot(e) {

        const frame = captureVideoFrame(e, "png");
        if (frame.dataUri.length < 10) {
            return swal("Please instruct the patient to turn on their camera!", "Patient's camera is off, the screenshot cannot be taken", "error")
        }
        setScreenShotDialogOpen(true)
        setImageBase(frame.dataUri)
    }

    const testNo = 16;

    useEffect(() => {
        if (props.IsWhiteBoardOpen) {
            setPinnedID(null)
            setPinnedIndex(null)
        }
    }, [props.IsWhiteBoardOpen])


    const MemoizedWhiteboard = useMemo(() => {
        return <Whiteboard
            stopWhiteboard={() => {
                props.stopWhiteboard()
            }}
            open={true}
            ChatBoxOpen={false}
            setControlBarOff={(e) => props.setControlBarOff()}
            setControlBarOn={(e) => props.setControlBarOn()}
        />
    }, [])


    // console.log(People, "People this")
    // console.log(People, "People this")

    // console.log({
    //     IsPatientHashMap,
    //     PatientsList
    // },"THIS IS IT")
    return (
        <div onClick={() => props.ChangeControlBarOpen()} style={{ height: "100%", width: "100%", overflow: "hidden", display: "flex" }} className="video-continer">
            {
                // this is the exerice video
                ExerciseVideoShow ? (
                    <div className="DragParent">
                        <Draggable bounds="body"  >
                            <div className="DragAbleBox">
                                <span onClick={() => {
                                    dispatch({
                                        type: Actions.SET_EXERCISE_VIDEO,
                                        payload: {
                                            show: false,
                                            poster: "",
                                            video: "",
                                        }
                                    })
                                    const EXERCISE = "EXERCISE"
                                    meetingSession?.audioVideo.realtimeSendDataMessage(EXERCISE, JSON.stringify({
                                        show: false,
                                        poster: "",
                                        video: "",
                                    }), 100000)
                                }}
                                    className="CLOSE"
                                >
                                    X
                                </span>
                                {
                                    ExerciseVideoVideo ? (
                                        <video
                                            // poster="/images/avatarpic.png"

                                            style={{ height: "100%", }}
                                            autoPlay
                                            poster={ExerciseVideoPoster}
                                            src={ExerciseVideoVideo} 
                                            muted={isHost}
                                            controls
                                            controlsList="nodownload"
                                            
                                            />

                                    ) : (
                                        <img
                                            style={{ height: "100%" }}
                                            src={ExerciseVideoPoster}
                                        />
                                    )
                                }
                            </div>
                        </Draggable>
                    </div>
                ) : null
            }

            {
                Loading ? (
                    <div className="MeetingLoader">
                        {
                            isMobileSafari ? (
                                <Snackbar
                                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                                    open={true}
                                    autoHideDuration={100000000}
                                    onClose={() => { }}
                                    message="Please wait while we connect you to the meeting! "
                                    key={"top" + "center"}
                                />
                            ) : null
                        }

                        <img src="/images/MyLoader3.gif" />
                    </div>
                ) :
                    (
                        <>

                            <div
                                style={
                                    IsMobTab ? { flexDirection: "column", width: "100%", height: "revert", display: ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "block" : "block", overflowY: "scroll", marginTop: ScreenShareOn ? "60%" : "0px", }
                                        : ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? { flexDirection: "column", width: "240px", overflowY: "scroll", display: "block", overflowX: "hidden", padding: "5px" }
                                            : { overflowY: Object.keys(People).length > 16 ? "scroll" : "scroll" }}
                                className={`VideoBoxesDiv ${ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "ScreenShareIsOn" : ""}`} >
                                <audio id="CHIME_AUDIO_TAG"></audio>
                                <audio id="DING_DONG" src="/media/join2.mp3"></audio>

                                {
                                    !props.ChatBoxOpen ? (
                                        <ToastContainer
                                            position="top-right"
                                            autoClose={4000}
                                            hideProgressBar={false}
                                            newestOnTop={false}
                                            closeOnClick
                                            rtl={false}
                                            pauseOnFocusLoss
                                            draggable
                                            pauseOnHover
                                        />
                                    ) : null
                                }
                                {
                                    Actions.VideoElementsForMap.map((value, index) => {
                                        // ["", "", "", "", "", "", "", "", "", "", "", "","", "", "", "", ].map((value, index) => {
                                        if (!SelectedVideoForROM && PatientsList?.length == 1 && PatientsList[0] == IsPatientHashMap[`isPatientID${index}`]?.UserID) {
                                            dispatch({
                                                type: Actions.SELECTING_ROM_USER,
                                                payload: `CHIME_VIDEO_TAG${index + 1}`
                                            })
                                        }
                                        // console.log(IsPatientHashMap)
                                        // if (PinnedID === `CHIME_VIDEO_TAG${index + 1}`) return null
                                        return (
                                            // use this to show videos
                                            <div
                                                hidden={PinnedIndex == index}
                                                key={index}
                                                //Object.keys(People).length
                                                style={
                                                    IsMobTab ? { ...StyleSheet.IsMobTab, height: Object.keys(People).length <= 1 ? "99.2%" : "49.2%" }
                                                        : ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? StyleSheet.ScreenShareOn
                                                            : WIdth > 767 && WIdth < 1023 && Object.keys(People).length <= 1 ? StyleSheet.LessThanOrEqualTo1
                                                                : WIdth > 767 && WIdth < 1023 && Object.keys(People).length == 2 ? StyleSheet.EqualTo2
                                                                    : WIdth > 767 && WIdth < 1023 && Object.keys(People).length >= 3 ? StyleSheet.SpecialTabMoreThan4
                                                                        : Object.keys(People).length <= 1 ? StyleSheet.LessThanOrEqualTo1
                                                                            : Object.keys(People).length == 2 ? StyleSheet.EqualTo2
                                                                                : Object.keys(People).length <= 4 ? StyleSheet.LessThanOrEqualTo4
                                                                                    : Object.keys(People).length <= 6 ? StyleSheet.LessThanOrEqualTo6
                                                                                        : Object.keys(People).length <= 9 ? StyleSheet.LessThanOrEqualTo7
                                                                                            : Object.keys(People).length <= 12 ? StyleSheet.LessThanOrEqualTo12
                                                                                                : Object.keys(People).length >= 13 ? StyleSheet.LessThanOrEqualTo16
                                                                                                    : {}}
                                                className="video "
                                                id={`CHIME_DIV_TAG${index + 1}`}
                                            >
                                                <video
                                                    style={{
                                                        boxShadow: !VideoTilesPeople.includes(People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.attendeeId) && IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.volume ? "inset 0 0 30px #4285f4, 0 0 30px #4285f4" : "",
                                                        transition: "box-shadow .4s",
                                                        transform: "rotateY(180deg)"
                                                    }}
                                                    controls={false}
                                                    autoPlay

                                                    // src={index > 3 && index < 8 ? "/media/asim.mp4" : ""}
                                                    className="video "
                                                    id={`CHIME_VIDEO_TAG${index + 1}`}
                                                />
                                                {
                                                    isHost && IsPatientHashMap[`isPatientID${index}`] && IsPatientHashMap[`isPatientID${index}`]?.UserID && PatientsList.includes(IsPatientHashMap[`isPatientID${index}`].UserID) ? (
                                                        // true ? (

                                                        //isPatientID${index}
                                                        <span style={ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? { color: "white", padding: Object.keys(People).length0, fontSize: "13px", top: "5px", } : { color: "white", top: "10px", right: "10px" }} className="HoverThingyEnable " >
                                                            <span style={{ display: "flex", alignItems: "center" }}>
                                                                <input
                                                                    checked={SelectedVideoForROM == `CHIME_VIDEO_TAG${index + 1}`}
                                                                    value={`CHIME_VIDEO_TAG${index + 1}`}
                                                                    style={{ cursor: "pointer" }}
                                                                    type="checkbox"
                                                                    onChange={() => {
                                                                        dispatch({
                                                                            type: Actions.SELECTING_ROM_USER,
                                                                            payload: `CHIME_VIDEO_TAG${index + 1}`
                                                                        })
                                                                    }}
                                                                />
                                                                <span
                                                                    onClick={() => {
                                                                        dispatch({
                                                                            type: Actions.SELECTING_ROM_USER,
                                                                            payload: `CHIME_VIDEO_TAG${index + 1}`
                                                                        })
                                                                    }}
                                                                    style={{ fontSize: ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "11px" : "14px", paddingLeft: "5px", fontWeight: "bold", cursor: "pointer" }}
                                                                >
                                                                    Enable ROM
                                                                </span>
                                                            </span>
                                                            {
                                                                SOAP ? (
                                                                    <span
                                                                        onClick={() => SaveScreenShot(`CHIME_VIDEO_TAG${index + 1}`)}
                                                                        style={{ display: "flex", alignItems: "center", cursor: "pointer", marginTop: "5px" }}
                                                                    >
                                                                        <img src="/images/expand.svg" />  <span style={{ fontSize: ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "11px" : "14px", paddingLeft: "5px", fontWeight: "bold" }}>Take Screenshot</span>
                                                                    </span>
                                                                ) : null
                                                            }
                                                        </span>
                                                    ) : null
                                                }

                                                {
                                                    !ScreenShareOn && !props.IsWhiteBoardOpen && !PinnedID && VideoTilesPeople.includes(People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.attendeeId) ? (
                                                        <span
                                                            onClick={() => {
                                                                if (PinnedID) {
                                                                    setPinnedID(null)
                                                                    setPinnedIndex(null)
                                                                } else {
                                                                    const name = document.getElementById(`HoverThingy${index}`).innerText
                                                                    setPinnedIndex(index)
                                                                    setPinnedID(`CHIME_VIDEO_TAG${index + 1}`)

                                                                    setTimeout(() => {
                                                                        meetingSession.audioVideo.bindVideoElement(index + 1, document.getElementById("ForPinned"));
                                                                        console.log("Pinned")
                                                                        document.getElementById("TheNewName").innerText = name

                                                                    }, 500)
                                                                }
                                                            }}
                                                            className="pinToView HoverThingyEnable"
                                                            style={{ top: "10px", left: "10px", cursor: "pointer" }}>
                                                            <img
                                                                style={{ height: "26px" }}
                                                                src="/images/pinA.png"
                                                            />
                                                        </span>
                                                    ) : null
                                                }


                                                <span style={ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? { color: "white", padding: 10, fontSize: "13px", bottom: "5px" } : { color: "white" }} className="HoverThingy " >
                                                    <span id={`HoverThingy${index}`}>

                                                    </span>
                                                    <img
                                                        style={{ marginLeft: "10px" }}
                                                        src={IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.muted ? "/images/mic-off.svg" : "/images/mic-white.svg"}
                                                    />
                                                    {/* {
                                                        console.log(IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.muted,IsPatientHashMap[`isPatientID${index}`]?.UserID,"TEST")
                                                    } */}
                                                    {/* <span>
                                                        {
                                                            IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.volume
                                                        }
                                                        {
                                                            console.log( IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.volume,"TEST")
                                                        }
                                                    </span> */}

                                                </span>
                                                {/* <span>
                                                    {
                                                        // IsPatientHashMap[`isPatientID${index}`] && People && console.log(People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.muted, "TEST")
                                                    }
                                                </span> */}
                                                {/* {
                                                    VideoTilesPeople.includes(People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.attendeeId) ? null : (
                                                        <span style={{
                                                            height: IsPatientHashMap[`isPatientID${index}`] && People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.volume ? `${People[IsPatientHashMap[`isPatientID${index}`]?.UserID]?.volume * 100}%` : "0%"
                                                        }} className="TheVolumeBar">

                                                        </span>
                                                    )
                                                } */}

                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={IsMobTab && ScreenShareOn ?
                                { position: "absolute", width: "100%", height: IsMobTab ? "fit-content" : "100%", justifyContent: "center", alignItems: "center", display: ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "flex" : "none", }
                                : { width: "100%", height: IsMobTab ? "fit-content" : "100%", justifyContent: "center", alignItems: "center", display: ScreenShareOn || props.IsWhiteBoardOpen || PinnedID ? "flex" : "none", }}>





                                {
                                    PinnedID ? (
                                        <video
                                            className="ScreenShareVideo "
                                            id="ForPinned"
                                            style={{ width: PinnedID && ScreenShareOn ? "50%" : "100%", objectFit: PinnedID && ScreenShareOn ? "cover" : "cover", display: !PinnedID ? "none" : "" }}
                                        >
                                        </video>
                                    ) : null
                                }
                                {
                                    PinnedID ? (
                                        <>
                                            <span
                                                onClick={() => {
                                                    setPinnedID(null)
                                                    setPinnedIndex(null)
                                                }}
                                                className="pinToView HoverThingyEnable"
                                                style={{ top: "10px", left: "210px", cursor: "pointer" }}>
                                                <img
                                                    style={{ height: "26px" }}
                                                    src="/images/pinB.png"
                                                />
                                            </span>
                                            <span
                                                // onClick={() => {
                                                //     setPinnedID(null)
                                                //     setPinnedIndex(null)
                                                // }}
                                                className="pinToView HoverThingyEnable"

                                                style={{ bottom: "20px", left: "210px", color: "white" }}>
                                                {/* <img
                                                    style={{ height: "26px" }}
                                                    src="/images/pinB.png"
                                                /> */}
                                                <span
                                                    id="TheNewName"
                                                    style={{ color: "white" }}
                                                >

                                                </span>

                                                <img
                                                    style={{ marginLeft: "10px" }}
                                                    src={IsPatientHashMap[`isPatientID${PinnedIndex}`] && People[IsPatientHashMap[`isPatientID${PinnedIndex}`]?.UserID]?.muted ? "/images/mic-off.svg" : "/images/mic-white.svg"}
                                                />
                                            </span>
                                        </>
                                    ) : null
                                }
                                <video
                                    // src="https://www.w3schools.com/tags/movie.mp4"
                                    style={{ width: PinnedID && ScreenShareOn ? "50%" : "100%", objectFit: PinnedID && ScreenShareOn ? "contain" : "contain", display: props.IsWhiteBoardOpen || props.AmISharingScreen || !ScreenShareOn ? "none" : "" }}
                                    className="ScreenShareVideo "
                                    id="Screen_share"
                                >

                                </video>
                                {

                                    props.IsWhiteBoardOpen ? (
                                        <>
                                            {MemoizedWhiteboard}
                                        </>
                                    ) : (
                                        <>
                                            {
                                                props.AmISharingScreen ? (
                                                    <div className="IAmSharingScreen">
                                                        <h1>
                                                            {
                                                                `${LocalUserName} is sharing screen!`
                                                            }
                                                        </h1>
                                                    </div>
                                                ) : (
                                                    null
                                                )
                                            }
                                        </>
                                    )

                                }

                            </div>
                        </>
                    )


            }




            {
                ScreenShotDialogOpen ? (
                    <ScreenShotDialog
                        open={ScreenShotDialogOpen}
                        close={() => setScreenShotDialogOpen(false)}
                        ImageBase={ImageBase}
                    />
                ) : null
            }


            {/* <MeetingControlBar
                ChatBoxOpen={props.ChatBoxOpen}
                CloseChatBox={props.CloseChatBox}
                openEndMeetingDialog={props.openEndMeetingDialog}
            /> */}
        </div >
    )
}

VideoContainer.propTypes = {
    AmISharingScreen: PropTypes.bool.isRequired,
}

export default VideoContainer

